import { useState } from "react";
import { accountService } from "@miplatform/api";
import { CONTACT_STATUSES, HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState, useRouter } from "@miplatform/hooks";
import { createUUID, extractDigits } from "@miplatform/utils";

const createContactUUID = createUUID();

export const useAddContactDrawerViewModel = ({ edit }) => {
  const stateManager = useComponentState();
  const { push } = useRouter();
  const [accounts, setAccounts] = useState([]);

  const getAccounts = () => {
    stateManager.run(async () => {
      const response = await accountService.accounts.getAll({
        sort: "name asc",
      });
      if (response.status === HTTP_STATUSES.OK) {
        setAccounts(
          response.data.map(({ name, id }) => ({
            label: name,
            value: id,
          }))
        );
      }
    });
  };

  const createContact = () => {
    stateManager.abort(createContactUUID);
    stateManager.run(async () => {
      const response = await accountService.contacts.create({
        data: {
          ...edit.getValue(),
          phone: extractDigits(edit.getValue("phone")),
          status: CONTACT_STATUSES.ACTIVE,
        },
        toastMessageConfig: {
          success: {
            text: `Contact was created successfully.`,
          },
        },
      });

      if (response.status === HTTP_STATUSES.CREATED) {
        push(
          `/settings/contact-management/accounts/${response.data.accountId}/contacts/${response.data.id}`
        );
      }
    }, createContactUUID);
  };

  return {
    getAccounts,
    accounts,
    createContact,
  };
};
